import React from 'react';
import PropTypes from 'prop-types';
import { ActiveCtaButton } from 'works/pages/supplier/staffing-requests/staffing-request/application-list-cta-buttons/active-cta-button';
import { OnHoldCtaButton } from 'works/pages/supplier/staffing-requests/staffing-request/application-list-cta-buttons/on-hold-cta-button';
import { FilledCancelledCtaButton } from 'works/pages/supplier/staffing-requests/staffing-request/application-list-cta-buttons/filled-cancelled-cta-button';

const SR_STATES = {
  open: 'OPEN',
  filled: 'FILLED',
  onHold: 'ON_HOLD',
  cancelled: 'CANCELLED',
  pending: 'PENDING',
};

export function ApplicationListCtaButton({ staffingRequest, application }) {
  if (staffingRequest.state === SR_STATES['open']) {
    return (
      <ActiveCtaButton
        staffingRequestId={staffingRequest.id}
        staffingRequestType={staffingRequest.staffingRequestType}
        application={application}
      />
    );
  }

  if (staffingRequest.state === SR_STATES['onHold']) {
    return <OnHoldCtaButton application={application} />;
  }

  if (
    staffingRequest.state === SR_STATES['filled'] ||
    staffingRequest.state === SR_STATES['cancelled']
  ) {
    return <FilledCancelledCtaButton application={application} />;
  }

  return null;
}

ApplicationListCtaButton.propTypes = {
  staffingRequest: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.oneOf(Object.values(SR_STATES)),
    staffingRequestType: PropTypes.string,
  }),
  worksProfile: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  application: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
  }),
};
